import { useState } from 'react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0); // First question is open by default

  const faqs = [
    {
      question: "Do you track my flight and adjust pickup time?",
      answer: "Yes. We use real-time flight tracking and adjust the pickup accordingly. Airport free wait is up to 60 minutes for international, 40 minutes for domestic (see booking for exact allowance)."
    },
    {
      question: "Where is the pickup point at the airport?",
      answer: "We meet at the designated curb-side pickup zone per airport rules. Detailed instructions are in your confirmation. We do provide meet n greet inside the terminals."
    },
    {
      question: "How long is the free wait time?",
      answer: "At airports up to 60 minutes for international, 40 minutes for domestic. For non-airport pickups, 15 minutes."
    },
    {
      question: "Can I change time or address after booking?",
      answer: "You may **contact support** to request changes; they're **subject to availability and price difference**."
    },
    {
      question: "Do you provide child seats?",
      answer: "Yes—**infant/child/booster** seats are available **on request**. Add it during booking."
    },
    {
      question: "Is service 24/7, including late-night or early-morning rides?",
      answer: "Yes. We operate **24/7 in New York (JFK/LGA/EWR)** and major cities worldwide, with **fixed fares by time band**."
    },
    {
      question: "What if I can't find my driver?",
      answer: "Check the **pickup instructions** in your confirmation and **message/call support 24/7**; we'll guide you to the correct zone."
    },
    
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-start">
          {/* Left Side - Content - Mobile: Second, Desktop: Left */}
          <div className="order-2 lg:order-1">
            {/* Mobile: Show image first */}
            <div className="w-full mb-6 lg:hidden">
              <img 
                src="https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png" 
                alt="Quality and Comfort in Black Car Services" 
                className="w-full h-64 sm:h-80 object-cover rounded-lg shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-64 sm:h-80 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            
            <div className="flex items-center mb-4">
              <h3 className="font-semibold">Frequently Asked Questions</h3>
            </div>
            <h2 className="font-semibold mb-4 sm:mb-6 leading-tight text-black">
              Questions? Find Answers for New York & Worldwide Airport Transfers
            </h2>
            <p className="mb-6 sm:mb-8 leading-relaxed text-gray-900">
              We focus on New York (JFK/LGA/EWR) with worldwide coverage. Here you'll find clear answers on booking, pricing, pickup points, free wait time, vehicles, and child seats. Still need help? Our agents are available 24/7.
            </p>
            
            {/* Desktop: Show image after text */}
            <div className="w-full hidden lg:block">
              <img 
                src="https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png" 
                alt="Quality and Comfort in Black Car Services" 
                className="w-full h-64 sm:h-80 lg:h-[320px] object-cover rounded-lg shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-64 sm:h-80 lg:h-[280px] bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
          </div>

          {/* Right Side - FAQ Accordion - Mobile: First, Desktop: Right */}
          <div className="space-y-4 order-1 lg:order-2">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                    openIndex === index 
                      ? 'bg-black text-white' 
                      : 'bg-gray-50 text-black hover:bg-gray-100'
                  }`}
                >
                  <span className="font-semibold pr-4 text-sm sm:text-base">{faq.question}</span>
                  <span className="flex-shrink-0">
                    {openIndex === index ? (
                      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                      </svg>
                    ) : (
                      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                    <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                      {faq.answer.split('**').map((part, i) => 
                        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                      )}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;











